import { MasterWithMappingType } from '../../../../types/master';
import { getMasterMappingsByPatternId } from './mapping/read';

// パターンに紐づくマスタ＋マッピングを取得する（master_mappings サブコレクション経由）
export const getMastersByPatternId = async (
  companyId: string,
  patternId: string,
): Promise<MasterWithMappingType[]> => {
  return getMasterMappingsByPatternId(companyId, patternId);
};
